import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';
import { cn } from 'cn';

import { Input } from '../ui/input';

function PasswordInput({ className, ...props }: React.ComponentProps<'input'>) {
  const [visivel, setVisivel] = React.useState(false);

  return (
    <div className="relative">
      <Input type={visivel ? 'text' : 'password'} className={cn('pr-9', className)} {...props} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisivel((v) => !v)}
        className="absolute top-1/2 right-3 -translate-y-1/2 text-muted-foreground transition-colors hover:text-foreground"
        aria-label={visivel ? 'Ocultar senha' : 'Mostrar senha'}
      >
        {visivel ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </button>
    </div>
  );
}

export { PasswordInput };
